import styled from '@emotion/styled';
import { Button, Image, Space } from 'antd';
import { FaArrowLeft, FaHome, FaSignInAlt } from 'react-icons/fa';
import { useHistory } from 'react-router';
import im404 from '../../../assets/images/404.svg';
import { ROUTES } from '../../../routes';
import { defaultImage } from '../../../shared/defaultImage';

const NotFoundContainer = styled.div`
  height: calc(100vh + 20px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e8edea;

  .title {
    font-size: 25px;
    text-align: center;
    color: red;
  }

  .text-description {
    font-size: 16px;
    text-align: center;
    color: black;
    margin-bottom: 20px;
  }

  > div {
    width: 300px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white;
  }

  @media (min-width: 768px) {
    > div {
      width: 500px;
    }
  }
`;

export const PageNotFound = () => {
  const router = useHistory();

  return (
    <NotFoundContainer>
      <div>
        <h3 className='title'>Page not found!!!</h3>
        <Image
          alt='pagenotfound'
          src={im404}
          width={250}
          style={{ objectFit: 'cover' }}
          preview={false}
          fallback={defaultImage}
        />
        <h3 className='text-description'>
          La ressource que vous avez demandé n'est pas disponible!
        </h3>
        <Space>
          <Button
            className='butt'
            size='large'
            icon={<FaArrowLeft style={{ marginBottom: -2, marginRight: 5 }} />}
            onClick={() => router.goBack()}
          >
            Retour
          </Button>
          <Button
            className='butt'
            size='large'
            icon={<FaHome style={{ marginBottom: -2, marginRight: 5 }} />}
            onClick={() => router.push(ROUTES.HOME_PAGE)}
          >
            Accueil
          </Button>
          <Button
            className='butt'
            size='large'
            icon={<FaSignInAlt style={{ marginBottom: -2, marginRight: 5 }} />}
            onClick={() => router.push(ROUTES.SIGNIN)}
          >
            Connexion
          </Button>
        </Space>
      </div>
    </NotFoundContainer>
  );
};
